(() => {
  if (window.ichikaOriginalRuntime) return;
  window.ichikaOriginalRuntime = true;
  const fragments = new Map();
  const partyExpanded = new WeakMap();
  function arrange() {
    document.querySelectorAll('[data-original-fragment]').forEach(fragment => {
      const name = fragment.dataset.originalFragment + ':' + fragment.dataset.originalSlotName;
      fragments.set(name, fragment.closest('.shopify-section') || fragment);
    });
    document.querySelectorAll('[data-original-lp]').forEach(root => {
      for (let pass = 0; pass < 25; pass++) {
        let moved = 0;
        root.querySelectorAll('[data-original-slot]').forEach(slot => {
          const node = fragments.get(root.dataset.originalLp + ':' + slot.dataset.originalSlot);
          if (node) { slot.replaceWith(node); moved++; }
        });
        if (!moved) break;
      }
    });
    window.ichikaOriginalFurisodeLooks?.();
    window.ichikaOriginalFurisodeFit?.();
    const previewThemeId = String(window.Shopify?.theme?.id || '');
    if (String(window.Shopify?.theme?.role).toLowerCase() === 'unpublished' && /^[0-9]+$/.test(previewThemeId)) {
      document.querySelectorAll('[data-original-lp] a[href]').forEach(link => {
        const url = new URL(link.href, location.href);
        const match = url.pathname.match(/^\/pages\/(wedding-mother|wedding-family|wedding-guest|furisode-guide)$/);
        if (url.origin === location.origin && match) {
          url.pathname = '/pages/scene-wedding';
          url.searchParams.set('view', match[1]);
          url.searchParams.set('preview_theme_id', previewThemeId);
          link.href = url.href;
        }
      });
    }
  }
  document.addEventListener('change', event => {
    const root = event.target.closest('[data-original-lp]');
    if (!root || !event.target.matches('input[type="checkbox"]')) return;
    const box = event.target.closest('#checklist,#family-checklist,#sg-check,.prep__list');
    if (box) {
      const n=box.querySelectorAll('input:checked').length,total=box.querySelectorAll('input').length;
      const count=root.querySelector('#count,#checked-count,#sg-check-count,.prep__count');
      if(count)count.textContent=box.id==='checklist'?`${n} / ${total} 点 確認できました`:box.matches('.prep__list')?`チェックしたアイテム：${n} / ${total}`:`${n} / ${total} 項目を確認しました`;
    }
  });
  document.addEventListener('click', event => {
    const root = event.target.closest('[data-original-lp]');
    if (!root) return;
    const choice=event.target.closest('[data-select],[data-outfit]');
    if(choice){
      const state=choice.dataset.select??choice.dataset.outfit;
      root.querySelectorAll('[data-coordinate-variant]').forEach(n=>n.hidden=n.dataset.coordinateVariant!==state);
      root.querySelectorAll('[data-select]').forEach(n=>n.setAttribute('aria-pressed',String(n.dataset.select===state)));
    }
    const role=event.target.closest('[data-role]');
    if(role){
      root.querySelectorAll('[data-role]').forEach(n=>n.setAttribute('aria-pressed',String(n===role)));
      root.querySelectorAll('[data-role-panel]').forEach(n=>n.hidden=n.dataset.rolePanel!==role.dataset.role);
      for(const [id,show] of [['mother-guide',role.dataset.role==='0'],['family-guide',['1','2','3'].includes(role.dataset.role)],['guest-guide',role.dataset.role==='4']]){const n=root.querySelector('#'+id);if(n)n.hidden=!show;}
    }
    const filter=event.target.closest('button[data-type]');
    if(filter){
      const type=filter.dataset.type;
      partyExpanded.set(root,new Set());
      root.querySelectorAll('button[data-type]').forEach(n=>n.setAttribute('aria-pressed',String(n===filter)));
      let total=0;const counts=[];
      root.querySelectorAll('.pv-group').forEach(group=>{
        let count=0;group.querySelectorAll('.pv-card').forEach(card=>{card.hidden=type!=='すべて'&&card.dataset.type!==type;card.classList.toggle('pv-extra',type==='すべて'&&count>=3);if(!card.hidden)count++;});
        total+=count;counts.push({id:group.id,title:group.querySelector('h3').textContent,count});
        const empty=group.querySelector('.pv-empty');if(empty)empty.hidden=count>0;
        const more=group.querySelector('.pv-more');if(more){more.hidden=type!=='すべて'||count<=3;more.setAttribute('aria-expanded','false');more.textContent=`ほかの${count-3}例を見る`;}
      });
      const count=root.querySelector('.pv-count');if(count)count.textContent=`${filter.textContent}：${total}件の組み合わせ`;
      const results=root.querySelector('.pv-scene-results');if(results){results.replaceChildren();counts.forEach(x=>{const n=document.createElement(x.count?'a':'span');n.textContent=x.count?`${x.title}：${x.count}例 ↓`:`${x.title}：掲載なし`;if(x.count)n.href='#'+x.id;results.append(n);});}
      const note=root.querySelector('.pv-result-note');if(note)note.hidden=type==='すべて';
    }
    const more=event.target.closest('.pv-more');
    if(more){
      const group=more.closest('.pv-group'),expanded=partyExpanded.get(root)||new Set();
      expanded.has(group.id)?expanded.delete(group.id):expanded.add(group.id);partyExpanded.set(root,expanded);
      const cards=[...group.querySelectorAll('.pv-card')];cards.forEach((card,i)=>card.classList.toggle('pv-extra',i>=3&&!expanded.has(group.id)));
      more.setAttribute('aria-expanded',String(expanded.has(group.id)));more.textContent=expanded.has(group.id)?'最初の3例に戻す':`ほかの${cards.length-3}例を見る`;
    }
    const ask = event.target.closest('[data-chat]');
    if (ask) {
      const dialog = root.querySelector('#chat');
      root.querySelector('#chat-topic').textContent = ask.dataset.chat;
      if (!dialog.open) dialog.showModal();
    }
    if (event.target.closest('.close,.close-chat')) root.querySelector('#chat')?.close();
  });
  document.addEventListener('shopify:section:load', arrange);
  document.addEventListener('shopify:section:reorder', arrange);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange);
  else arrange();
})();
